import React from 'react'
import { withStyles } from '@material-ui/core/styles';
import Fab from '@material-ui/core/Fab';
import ChatBubbleIcon from '@material-ui/icons/ChatBubble';
import Paper from '@material-ui/core/Paper';

import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Input from '@material-ui/core/Input';
import SendIcon from '@material-ui/icons/Send';
import ChatUsers from './ChatUsers';
import Typography from '@material-ui/core/Typography';
import { getRoom, getCollection } from '../../constant';

import { firestoreConnect } from 'react-redux-firebase'
import { compose } from 'redux'
import { connect } from 'react-redux'
import moment from "moment";
import classNames from 'classnames'



const styles = theme => ({
  msgInputMain: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: '100%'
  },
  msgInput: {
    paddingRight: 50,
    paddingLeft: 10,
    paddingBottom: 15,
    width: '100%',
    background: '#fff'
  },
  bubble: {
    position: 'relative',
    background: '#00aabb',
    borderRadius: '.4em',
    maxWidth: 'calc(100% - 50px)',
    padding: '15px 10px',
    display: 'inline-block',
    textAlign: 'left',
    margin: '10px 0 0',
    color: '#fff',
    minWidth: 100,
    wordBreak: 'break-all'
  },

  otherBubbleBg: {
    background: '#ccc',
    color: '#000'
  },

  selfBubbleMain: {
    marginRight: 15,
    textAlign: 'right',
  },

  bubbleCommon: {
    position: 'absolute',
    // top: '50%',
    bottom: 7,
    width: 0,
    height: 0,
    border: '15px solid transparent',
    marginTop: -10,
    borderBottom: 0
  },

  selfBubble: {
    content: '',
    right: 0,
    borderLeftColor: '#00aabb',
    borderRight: 0,
    marginRight: -15
  },

  otherBubbleMain: {
    marginLeft: 15,
  },
  otherBubble: {
    left: 0,
    borderRightColor: '#ccc',
    borderLeft: 0,
    marginLeft: -15,
  },

  date: {
    margin: 0,
    color: '#999',
    fontSize: 10,
    marginBottom: 10,
    padding: '0 5px'
  }

});

class ChatSingle extends React.Component {

  componentDidMount() {
    const { profile, msg, firestore, notifications = [] } = this.props;
    if (msg.sanderId != profile.id) {
      notifications.forEach(notification => {
        if (notification.messageId == msg.id) {
          firestore.collection(getCollection(profile, 'chatNotifications')).doc(notification.id).delete()
            .then((data) => {
            }, (err) => {
            });
        }
      });
    }
  }

  render() {
    const { classes, profile, msg } = this.props;
    const { bubble, bubbleCommon, selfBubble, selfBubbleMain, otherBubbleMain, otherBubble, otherBubbleBg, date } = classes;

    return (
      <React.Fragment>
        {
          msg.sanderId == profile.id
            ?
            <div key={msg.id} className={selfBubbleMain}>
              <div className={bubble}>
                <div dangerouslySetInnerHTML={{ __html: msg.text }}></div>
                <span className={classNames(bubbleCommon, selfBubble)} />
              </div>
              <p className={date}>{moment(msg.createdAt).fromNow()}</p>
            </div>
            :
            <div key={msg.id} className={otherBubbleMain}>
              <div className={classNames(bubble, otherBubbleBg)}>
                <div dangerouslySetInnerHTML={{ __html: msg.text }}></div>
                <span className={classNames(bubbleCommon, otherBubble)} />
              </div>
              <p className={date}>{moment(msg.createdAt).fromNow()}</p>
            </div>
        }
      </React.Fragment>
    )

  }
}


export default withStyles(styles)(ChatSingle)